import { get } from 'lodash';
import { enrich } from 'state/helpers';

// eslint-disable-next-line import/prefer-default-export
export function selectStatus(slice) {
  return get(slice, 'status', enrich());
}
